<template>
  <el-dialog
    v-model="dialogVisible"
    title=""
    width="1024px"
    :show-close="false"
    :close-on-click-modal="false"
    modal-class="program-assignee-dialog-workflow"
    append-to-body
  >
    <!-- Custom Header -->
    <template #header>
      <div class="dialog-header">
        <div class="header-title">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H10V4H2V18H16V12H18V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM4 16H6V9H4V16ZM8 16H10V6H8V16ZM12 16H14V12H12V16ZM17 10C16.5 10 16.0083 9.925 15.525 9.775C15.0417 9.625 14.5917 9.40833 14.175 9.125L13.8 9.475C13.6 9.65833 13.3625 9.75 13.0875 9.75C12.8125 9.75 12.5833 9.65833 12.4 9.475C12.2167 9.29167 12.125 9.05833 12.125 8.775C12.125 8.49167 12.2167 8.25833 12.4 8.075L12.8 7.675C12.5333 7.275 12.3333 6.85 12.2 6.4C12.0667 5.95 12 5.48333 12 5C12 3.61667 12.4875 2.4375 13.4625 1.4625C14.4375 0.4875 15.6167 0 17 0H22V5C22 6.38333 21.5125 7.5625 20.5375 8.5375C19.5625 9.5125 18.3833 10 17 10ZM17 8C17.8333 8 18.5417 7.70833 19.125 7.125C19.7083 6.54167 20 5.83333 20 5V2H17C16.1667 2 15.4583 2.29167 14.875 2.875C14.2917 3.45833 14 4.16667 14 5C14 5.21667 14.0208 5.425 14.0625 5.625C14.1042 5.825 14.1667 6.025 14.25 6.225L16.85 3.625C17.0333 3.44167 17.2667 3.35 17.55 3.35C17.8333 3.35 18.0667 3.44167 18.25 3.625C18.45 3.825 18.55 4.0625 18.55 4.3375C18.55 4.6125 18.45 4.85 18.25 5.05L15.65 7.65C15.8667 7.75 16.0875 7.83333 16.3125 7.9C16.5375 7.96667 16.7667 8 17 8Z" fill="white"/>
          </svg>
          <span>Program Preview</span>
        </div>
        <button class="close-btn" @click="closeDialog">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="white"/>
          </svg>
        </button>
      </div>
    </template>

    <!-- Dialog Content -->
    <div class="dialog-content">
      <div class="content-wrapper">
        <!-- Program Details Section -->
        <div class="program-details-section">
          <div class="section-header">
            <img src="@/assets/MyWorkBench/Workflow/program_detail.svg" alt="Program Details" class="section-icon" />
            <span class="section-title">Program Details</span>
          </div>

          <div class="program-general">
            <div class="program-name">{{ programName }}</div>
            <div class="program-description">{{ programDescription }}</div>
          </div>

          <div class="program-meta-grid">
            <div class="meta-column">
              <div class="meta-item">
                <img src="@/assets/MyWorkBench/Workflow/program_duration.svg" alt="Duration" class="meta-icon" />
                <span class="meta-label">Duration:</span>
                <span class="meta-value">{{ programDuration }}</span>
              </div>

              <div class="meta-item">
                <img src="@/assets/MyWorkBench/Workflow/program_enrollment.svg" alt="Enrollment Control" class="meta-icon" />
                <span class="meta-label">Enrollment Control:</span>
                <span class="meta-value">{{ enrollmentControl }}</span>
              </div>
            </div>

            <div class="meta-column">
              <div class="meta-item">
                <img src="@/assets/MyWorkBench/Workflow/program_assignee.svg" alt="Current Assignees" class="meta-icon" />
                <span class="meta-label">Current Assignees:</span>
                <span class="meta-value">{{ currentAssignees }}</span>
              </div>

              <div class="meta-item">
                <img src="@/assets/MyWorkBench/Workflow/program_price.svg" alt="Program Price" class="meta-icon" />
                <span class="meta-label">Program Price:</span>
                <span class="meta-value">{{ programPrice }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="divider"></div>

        <!-- Current Assignees Section -->
        <div class="assignees-section">
          <div class="assignees-header">
            <div class="section-header">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M9.9987 4.91659C10.9654 4.91659 11.7487 5.69992 11.7487 6.66659C11.7487 7.63325 10.9654 8.41659 9.9987 8.41659C9.03203 8.41659 8.2487 7.63325 8.2487 6.66659C8.2487 5.69992 9.03203 4.91659 9.9987 4.91659ZM9.9987 12.4166C12.4737 12.4166 15.082 13.6333 15.082 14.1666V15.0833H4.91536V14.1666C4.91536 13.6333 7.5237 12.4166 9.9987 12.4166ZM9.9987 3.33325C8.15703 3.33325 6.66536 4.82492 6.66536 6.66659C6.66536 8.50825 8.15703 9.99992 9.9987 9.99992C11.8404 9.99992 13.332 8.50825 13.332 6.66659C13.332 4.82492 11.8404 3.33325 9.9987 3.33325ZM9.9987 10.8333C7.7737 10.8333 3.33203 11.9499 3.33203 14.1666V16.6666H16.6654V14.1666C16.6654 11.9499 12.2237 10.8333 9.9987 10.8333Z" fill="#004879"/>
              </svg>
              <span class="section-title">Current Assignees</span>
            </div>
            <button class="add-patients-btn" @click="handleAddPatients">
              <img src="@/assets/MyWorkBench/Workflow/program_add.svg" alt="Add" class="add-icon" />
              <span>Add Patients</span>
            </button>
          </div>

          <!-- Assignee List -->
          <div class="assignee-list-container">
            <div v-if="assignees.length === 0" class="empty-state">
              <img src="@/assets/MyWorkBench/Workflow/program_no_assignee.svg" alt="Empty State" />
            </div>
            <div v-else class="assignee-list">
              <ProgramAssigneeItem
                v-for="assignee in assignees"
                :key="assignee.id"
                :assignee="assignee"
                :program-steps-total="programStepsTotal"
                @toggle-pause="handleTogglePause"
                @remove="handleRemoveAssignee"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Dialog Footer -->
    <template #footer>
      <div class="dialog-footer">
        <NewLibraryButton
          type="normal"
          color-type="red-stroke"
          @click="closeDialog"
        >
          Cancel
        </NewLibraryButton>
        <div class="footer-right-actions">
          <NewLibraryButton
            v-if="assignees.length === 0"
            type="normal"
            color-type="dark-blue-stroke"
            @click="handleEdit"
          >
            Edit
          </NewLibraryButton>
          <NewLibraryButton
            type="normal"
            color-type="dark-blue"
            @click="handleAddPatients"
          >
            Add Assignees
          </NewLibraryButton>
        </div>
      </div>
    </template>

    <!-- Remove Patient Confirmation Dialog -->
    <RemovePatientConfirmationDialog
      :visible="showRemoveDialog"
      :patient="patientToRemove"
      :program-id="programId"
      @close="showRemoveDialog = false"
      @success="handleRemoveSuccess"
    />
  </el-dialog>
</template>

<script>
import NewLibraryButton from '@/NewLibrary/Button.vue';
import ProgramAssigneeItem from './ProgramAssigneeItem.vue';
import RemovePatientConfirmationDialog from '@/views/my-workbench-new/workflow/Dialogs/RemovePatientConfirmationDialog.vue';
import { notify } from '@/utils/notify';
import { 
  getWorkflowAssigneesApi, 
  pausePatientAssignmentApi, 
  resumePatientAssignmentApi, 
  unassignPatientFromWorkflowApi 
} from '@/api/workflowManage';

export default {
  name: 'ProgramAssigneeDialog',
  components: {
    NewLibraryButton,
    ProgramAssigneeItem,
    RemovePatientConfirmationDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    program: {
      type: Object,
      required: true
    }
  },
  emits: ['close', 'save', 'open-add-assignee', 'assignees-updated', 'open-edit', 'assignees-list-updated'],
  data() {
    return {
      localProgram: null,
      assignees: [],
      loading: false,
      programStepsTotal: 0,
      initialEnrollmentCount: 0,
      showRemoveDialog: false,
      patientToRemove: {}
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.closeDialog();
        }
      }
    },
    programId() {
      return this.localProgram?.id || this.program?.id || '';
    },
    programName() {
      return this.localProgram?.name || '';
    },
    programDescription() {
      return this.localProgram?.description || 'No description provided';
    },
    programDuration() {
      if (!this.localProgram?.duration) return 'N/A';
      const { type, value, unit } = this.localProgram.duration;
      if (type === 'rolling') {
        return `${value} ${unit}`;
      } else if (type === 'fixed') {
        return this.localProgram.duration.end_date || 'N/A';
      }
      return 'N/A';
    },
    currentAssignees() {
      return this.nonCompletedAssigneeCount;
    },
    nonCompletedAssigneeCount() {
      return this.assignees.filter(a => a.status !== 'completed').length;
    },
    isMaxEnrollmentReached() {
      if (!this.localProgram?.maximum_enrollment) return false;
      return this.nonCompletedAssigneeCount >= this.localProgram.maximum_enrollment;
    },
    enrollmentControl() {
      return this.localProgram?.maximum_enrollment || 'None';
    },
    programPrice() {
      if (!this.localProgram?.price) return '$0.00';
      return `$${parseFloat(this.localProgram.price).toFixed(2)}`;
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.initializeDialog();
      }
    },
    program: {
      handler(newVal) {
        if (newVal && this.visible) {
          this.initializeDialog();
        }
      },
      deep: true
    },
    assignees: {
      handler() {
        // Emit updated count whenever assignees list changes
        this.$emit('assignees-updated', {
          programId: this.programId,
          assigneeCount: this.assignees.length
        });
        // Also emit the full assignees list for enrollment control calculation
        this.$emit('assignees-list-updated', {
          assignees: this.assignees
        });
      },
      deep: true
    }
  },
  mounted() {
    // Initialize if dialog is already visible on mount
    if (this.visible && this.program) {
      this.initializeDialog();
    }
  },
  methods: {
    initializeDialog() {
      // Deep copy the program object to local data
      this.localProgram = JSON.parse(JSON.stringify(this.program));
      // Store initial enrollment count for tracking
      this.initialEnrollmentCount = this.program.current_enrollment_count || 0;
      this.loadAssignees();
    },
    closeDialog() {
      this.$emit('close');
    },

    async loadAssignees() {
      if (!this.programId) return;

      try {
        this.loading = true;
        const response = await getWorkflowAssigneesApi(this.programId);
        console.log('Loaded assignees response:', response);
        
        // Store program steps total
        this.programStepsTotal = response.data?.program_steps_total || 0;
        
        // Pass raw API data to component - let ProgramAssigneeItem handle transformations
        this.assignees = (response.data?.assignments || []).map(assignment => ({
          id: assignment.patient_id,
          name: assignment.patient_name || `Patient ${assignment.patient_id}`,
          avatar: assignment.patient_avatar || null,
          initials: this.getInitials(assignment.patient_name || `Patient ${assignment.patient_id}`),
          bioGender: assignment.bio_gender || 'N/A',
          dob: this.formatDate(assignment.date_of_birth),
          joinedDate: this.formatDate(assignment.assigned_at),
          status: assignment.status,
          isPaused: assignment.status === 'paused',
          // Keep raw API fields for component to process
          program_steps_executed: assignment.program_steps_executed,
          program_start_date: assignment.program_start_date,
          program_end_date: assignment.program_end_date
        }));

        console.log('Loaded assignees:', this.assignees);
        console.log('Program steps total:', this.programStepsTotal);
      } catch (error) {
        console.error('Error loading assignees:', error);
        notify({
          title: 'Error',
          message: `Failed to load assignees: ${error.response?.data?.message || error.message}`,
          type: 'error',
          showClose: true
        });
      } finally {
        this.loading = false;
      }
    },

    getInitials(name) {
      if (!name) return '?';
      const parts = name.split(' ');
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    },

    async handleTogglePause(assigneeId) {
      const assignee = this.assignees.find(a => a.id === assigneeId);
      if (!assignee) return;

      await this.handlePauseResume(assignee);
    },

    async handlePauseResume(assignee) {
      try {
        if (assignee.isPaused) {
          // Resume the patient
          await resumePatientAssignmentApi(this.programId, assignee.id);
          assignee.isPaused = false;
          assignee.status = 'running';
          
          notify({
            title: 'Success',
            message: `Patient ${assignee.name} resumed successfully`,
            type: 'success',
            showClose: true
          });
        } else {
          // Pause the patient
          await pausePatientAssignmentApi(this.programId, assignee.id);
          assignee.isPaused = true;
          assignee.status = 'paused';
          
          notify({
            title: 'Success',
            message: `Patient ${assignee.name} paused successfully`,
            type: 'success',
            showClose: true
          });
        }
      } catch (error) {
        console.error('Error toggling pause status:', error);
        notify({
          title: 'Error',
          message: `Failed to ${assignee.isPaused ? 'resume' : 'pause'} patient: ${error.response?.data?.message || error.message}`,
          type: 'error',
          showClose: true
        });
      }
    },


    handleRemoveAssignee(assigneeId) {
      const assignee = this.assignees.find(a => a.id === assigneeId);
      if (!assignee) return;

      // Set patient data and show confirmation dialog
      this.patientToRemove = assignee;
      this.showRemoveDialog = true;
    },

    async handleRemoveSuccess() {
      // Reload assignees after successful removal
      this.showRemoveDialog = false;
      await this.loadAssignees();
    },

    handleEdit() {
      // Emit event to parent to handle dialog transition
      this.$emit('open-edit');
    },

    handleSave() {
      // Emit the modified local program data back to parent
      this.$emit('save', this.localProgram);
      this.closeDialog();
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { 
          year: 'numeric', 
          month: 'short', 
          day: 'numeric' 
        });
      } catch (error) {
        return dateString;
      }
    },

    handleAddPatients() {
      // Emit event to parent to handle dialog transition
      this.$emit('open-add-assignee');
      // Close this dialog
      this.closeDialog();
    }
  }
};
</script>

<style scoped>
/* Dialog Header */
.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: #004879;
  border-radius: 10px 10px 0 0;
}

.header-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-title span {
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: #FFFFFF;
}

.close-btn {
  width: 24px;
  height: 24px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  opacity: 0.8;
}

/* Dialog Content */
.dialog-content {
  padding: 16px 32px;
  background: #F9FBFD;
  max-height: calc(80vh - 200px);
  overflow-y: auto;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 16px;
}

/* Program Details Section */
.program-details-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: transparent;
  padding: 16px;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 6px;
}

.section-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.section-title {
  font-family: 'Avenir', sans-serif;
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #333;
}

.program-general {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.program-name {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #666;
  margin-bottom: 4px;
}

.program-description {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #666;
}

.program-meta-grid {
  display: flex;
  gap: 32px;
}

.meta-column {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 24px;
}

.meta-label {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #4a4a4a;
  white-space: nowrap;
}

.meta-value {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #4a4a4a;
  white-space: nowrap;
}

/* Assignees Section */
.assignees-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.assignees-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.add-patients-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background: transparent;
  border: none;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #1e4670;
  cursor: pointer;
  transition: opacity 0.2s ease;
  text-decoration: underline;
}

.add-patients-btn:hover {
  opacity: 0.8;
}

.add-icon {
  width: 18px;
  height: 18px;
}

.assignee-list-container {
  background: white;
  border-radius: 10px;
  padding: 12px 24px;
  margin: 0 16px;
}

.assignee-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 8px;
}

.empty-state img {
  max-width: 400px;
}

.empty-text {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  color: #9ca3af;
}

/* Dialog Footer */
.dialog-footer {
  border-top: 1px dashed #c4c4c4;
  padding: 24px;
  background: #F9FBFD;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-right-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.divider {
  border-bottom: 1px dashed #c4c4c4;
}
</style>
